import React, {useEffect, useState} from 'react';

import {strings} from '../../../../../../util/strings';
import {LatLngInterface, ItemInterface, Nullable} from '../locationTypes';

import {LocationPinIcon} from '../../../../LocationPinIcon';
import { connect } from 'react-redux';
import { compose } from 'redux';
import GenericMapWithMarker from '../../../GenericMapWithMarker';

const OVERLAY_VIEW_POSITION_OFFSET = {x: -105, y: -210};

interface LocationProps {
  locations: ItemInterface[];
  showFullMap: boolean;
  infoBoxPosition: LatLngInterface | null;
  buStyles: any;
  handleChangeInfoBoxPosition(value: Nullable<LatLngInterface>): void;
  handleOnClickLocationDetails(value?: number): void;
  showPrice: boolean;
  expandMap(): void;
  precoEstimadoFuncAtiva: boolean;
  labels: typeof strings.pt.rede;
}

function LocationsMap({
  locations,
  showFullMap,
  infoBoxPosition,
  handleChangeInfoBoxPosition,
  handleOnClickLocationDetails,
  showPrice,
  expandMap,
  buStyles,
  precoEstimadoFuncAtiva,
  labels,
}: LocationProps) {
  const [currentMap, setCurrentMap] = useState<google.maps.Map | null>(null);

  const handleMarkerClick = (
    index: number,
    latitude: number,
    longitude: number
  ) => handleChangeInfoBoxPosition({lat: latitude, lng: longitude});

  const onClickLocationDetails = (item: ItemInterface) => {
    handleOnClickLocationDetails(item.code);
  };

  const onLoad = (map: google.maps.Map) => {
    setCurrentMap(map);
  };

  useEffect(() => {
    if (currentMap && infoBoxPosition?.lat && infoBoxPosition?.lng) {
      currentMap.panTo(
        new window.google.maps.LatLng(infoBoxPosition.lat, infoBoxPosition.lng)
      );
    }
  }, [currentMap, infoBoxPosition]);

  useEffect(() => {
    const existingMarkerStr = localStorage.getItem('existingMarker');
    if (existingMarkerStr) {
      const existingMarkerObj = JSON.parse(existingMarkerStr);
      handleChangeInfoBoxPosition({
        lat: existingMarkerObj.lat,
        lng: existingMarkerObj.lng,
      });
      localStorage.removeItem('existingMarker');
    }
  }, []);

  return (
    <div className="location-map-container">
      <div className="location-map-header">
        <span>
          {/* {!showFullMap && labels?.medicalNetwork_locations_move_map_info} */}
        </span>
        <div className="location-expand-map">
          <LocationPinIcon
            color={buStyles.primaryColor}
            width="22px"
            height="18px"
          />
          <span onClick={expandMap} style={{color: buStyles.primaryColor}}>
            {!showFullMap
              ? labels?.medicalNetwork_locations_expand_map
              : labels?.medicalNetwork_locations_shrink_map}
          </span>
        </div>
      </div>
      <GenericMapWithMarker
        enablePriceMarker={true}
        buStyles={buStyles}
        offset={OVERLAY_VIEW_POSITION_OFFSET}
        currentMap={currentMap}
        onLoad={onLoad}
        locations={locations}
        precoEstimadoFuncAtiva={precoEstimadoFuncAtiva}
        showPrice={showPrice}
        infoBoxPosition={infoBoxPosition}
        zoom={12}
        dynamicZoom
        handleMarkerClick={handleMarkerClick}
        handleChangeInfoBoxPosition={handleChangeInfoBoxPosition}
        onClickLocationDetails={onClickLocationDetails}
        containerStyleClassName="location-map-component"
      />
    </div>
  );
}

const mapStateToProps = ({strings}: any) => ({
  labels: strings.value.pt.rede,
});

export default compose(connect(mapStateToProps)(LocationsMap));
